export default "__VITE_ASSET__CKjb$hzb__"